import { Avatar, List, ListItemText, Typography } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import { chartColors } from '../../theme';
import { PageHandle } from '../dashboards/types';

import ListItemButton from '@mui/material/ListItemButton';
import { useGlobalLocaleContext } from '../../../context/contexts';

const StyledAvatar = styled(Avatar)<{
  $backgroundColor: string;
}>`
  background-color: ${(props) => props.$backgroundColor || '#bdbdbd'};
  width: 24px;
  height: 24px;
  margin-right: 15px;
`;

interface PageNumbersProps {
  pageHandle: PageHandle;
}

export const PageNumbers = (props: PageNumbersProps) => {
  const { pageHandle } = props;
  const locale = useGlobalLocaleContext();
  return (
    <List className="intercom_sidebar_db">
      {pageHandle.pages
        .filter((p) => p.enabled)
        .map((page, index) => (
          <ListItemButton
            key={page.pageId}
            sx={{ paddingTop: '4px', paddingBottom: '4px' }}
            className="intercom_sidebar_db-tab"
            onClick={() => pageHandle.setter(page)}
          >
            <StyledAvatar
              $backgroundColor={
                pageHandle.selected.pageNumber === page.pageNumber
                  ? chartColors[0]
                  : '#bdbdbd'
              }
            >
              {index + 1}
            </StyledAvatar>
            <ListItemText
              primary={
                <Typography noWrap variant="caption">
                  {page.title[locale.selected]}
                </Typography>
              }
              disableTypography
            />
          </ListItemButton>
        ))}
    </List>
  );
};
